// extracted by mini-css-extract-plugin
export default {"containerMain":"Medico_containerMain__oroXa","divForm":"Medico_divForm__cXPIW","modal":"Medico_modal__pFnvv","botoes":"Medico_botoes__1rgRd"};